import React from 'react';
import { useLocation } from 'react-router';
import $ from 'jquery';

const ScrollToTop = (props: { children: JSX.Element }) => {
  const location = useLocation();
  React.useEffect(() => {
    const scroll = $('html, body').scrollTop();
    if (!scroll) return;
    $('html, body').animate({ scrollTop: 0 }, scroll / 2);
  }, [location]);

  return <>{props.children}</>;
};

export default ScrollToTop;
